import { Directive, Input, ElementRef, Renderer2, OnChanges, SimpleChanges } from '@angular/core';

@Directive({
    selector: '[layoutAlign]',
    standalone: false
})
export class LayoutAlignDirective implements OnChanges {
    @Input() layoutAlign: string = '';

    private readonly _directiveName = 'layoutAlign';

    constructor(private el: ElementRef, private renderer: Renderer2) { }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['layoutAlign']) {
            this.updateAlign();
        }
    }

    private updateAlign(): void {
        const [justify = '', align = ''] = this.layoutAlign.split(' ');

        const justifyContent = this.toFlexValue(justify);
        const alignItems = this.toFlexValue(align);

        if (justifyContent) {
            this.renderer.setStyle(this.el.nativeElement, 'justify-content', justifyContent);
        }
        if (alignItems) {
            this.renderer.setStyle(this.el.nativeElement, 'align-items', alignItems);
        }
    }

    private toFlexValue(value: string): string | null {
        switch (value) {
            case 'start': return 'flex-start';
            case 'end': return 'flex-end';
            case 'center': return 'center';
            case 'stretch': return 'stretch';
            case 'space-between': return 'space-between';
            case 'space-around': return 'space-around';
            default:
                if (value) {
                    console.warn(`[${this._directiveName}] Invalid align value "${value}".`);
                }
                return null;
        }
    }
}